// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Article24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Article24CircleFilled: FC<Article24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="M17.778 20.445h-6.222v-1.778h6.222v1.777ZM20.445 16.889h-8.89V15.11h8.89v1.778ZM20.445 13.333h-8.89v-1.777h8.89v1.777Z" />
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-7.478-8.522c.348.348.767.522 1.256.522h12.444c.49 0 .908-.174 1.256-.522.348-.348.522-.767.522-1.256V9.778c0-.49-.174-.908-.522-1.256A1.712 1.712 0 0 0 22.222 8H9.778c-.49 0-.908.174-1.256.522A1.712 1.712 0 0 0 8 9.778v12.444c0 .49.174.908.522 1.256Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Article24CircleFilled;
